import React, { useRef, useState, useEffect } from 'react';

import jsPDF from 'jspdf';
import apiClient from '../../apiClient';
import html2canvas from 'html2canvas';
import { numberToWordsIndian } from '../../utlis/numberToWordsIndian';
import { formatCurrency } from '../../utlis/formatCurrency';
import POHeader from '../../Component/PO/POHeader';
import { supplier as defaultSupplier } from '../../constants/invoiceConstants';

import Button from '../../Component/common/Button/Button';

import "./PoCreate.css";

const PoCreate = ({ onBack }) => {
  const poRef = useRef();

  const [poData, setPoData] = useState({
    po_number: "PO/VC/25-26/001",
    po_date: "2025-11-15",
    supplier: defaultSupplier,
    delivery_date: "2025-11-20",
    place_of_supply: "GUJARAT",
    project: "VC",
    summary: "-",
    vendor_name: "",
    vendor_address: ``,
    vendor_phone: "",
    vendor_email: "",
    vendor_gst: "",
    buyer_phone: "",
    buyer_email: "",
    deliver_to: `Mangal trade hub, Office no 628,
Near Billabong international school, Vadsar,
Vadodara, Gujarat - 390010
India`,
    items: [
      {
        description: "BRASS FITTING M-12X134 WITH PLATING\nHSN: 85049010",
        qty: 50,
        rate: 280,
        igst: 18
      }
    ],
    terms: `1. Acceptance of Purchase Order...
2. Compliance of GST laws...`
  });

  const [totals, setTotals] = useState({
    subtotal: 0,
    igst: 0,
    total: 0
  });

  useEffect(() => {
    let subtotal = 0;
    let igst = 0;

    poData.items.forEach(item => {
      const amount = item.qty * item.rate;
      subtotal += amount;
      igst += (amount * item.igst) / 100;
    });

    setTotals({
      subtotal,
      igst,
      total: subtotal + igst
    });
  }, [poData.items]);

  const downloadPDF = async () => {
    const canvas = await html2canvas(poRef.current, { scale: 2 });
    const imgData = canvas.toDataURL("image/jpeg", 0.95);

    const pdf = new jsPDF("p", "mm", "a4");
    pdf.addImage(imgData, "JPEG", 0, 0, 210, 297);
    pdf.save(`PO_${poData.po_number}.pdf`);
  };

  return (
    <div className="po-page">
      <div className="top-bar">
        <Button onClick={onBack}>Back</Button>
        <Button onClick={downloadPDF}>Download PDF</Button>
    
      </div>
      

      <div className="po-container" ref={poRef}>

        {/* HEADER GRID */}
        <div className="po-header-grid">
          <POHeader supplier={poData.supplier} />
          <div className="po-title-box">
            <h1>PURCHASE ORDER</h1>
          </div>
        </div>

        {/* META GRID */}
        <div className="po-meta-grid">
          <div>Purchase Order# : {poData.po_number}</div>
          <div>Place Of Supply : {poData.place_of_supply}</div>
          <div>Date : {poData.po_date}</div>
          <div>PROJECT/OA : {poData.project}</div>
          <div>Delivery Date : {poData.delivery_date}</div>
          <div>SUMMARY : {poData.summary}</div>
        </div>

        {/* ADDRESS GRID */}
        {/* ================== Vendor ADDRESS ================= */}
       <div className="po-address-grid">
        <div>
          <h4>Vendor Address</h4>

          <input
            type="text"
            className="po-input"
            value={poData.vendor_name}
            onChange={(e) =>
              setPoData(prev => ({ ...prev, vendor_name: e.target.value }))
            }
            placeholder="Vendor Name"
          />

          <textarea
            className="po-textarea"
            rows={4}
            value={poData.vendor_address}
            onChange={(e) =>
              setPoData(prev => ({ ...prev, vendor_address: e.target.value }))
            }
            placeholder="Vendor Address"
          />

          <input
            type="text"
            className="po-input"
            value={poData.vendor_gst}
            onChange={(e) =>
              setPoData(prev => ({ ...prev, vendor_gst: e.target.value }))
            }
            placeholder="GSTIN"
          />

            <input
          type="text"
          className="po-input"
          value={poData.vendor_phone}
          onChange={(e) =>
            setPoData(prev => ({ ...prev, vendor_phone: e.target.value }))
          }          
          placeholder="Contact"
        />

            <input
          type="text"
          className="po-input"
          value={poData.vendor_email}
          onChange={(e) =>
            setPoData(prev => ({ ...prev, vendor_email: e.target.value }))
          }
          placeholder="Email"
        />
        </div>

        {/* ================== Vidyutcloud/ Buyer ADDRESS ================= */}

        <div>
          <h4>Deliver To</h4>

          <input
            type="text"
            className="po-input"
            value={poData.supplier.name}
            onChange={(e) =>
              setPoData(prev => ({ ...prev, supplier: { ...prev.supplier, name: e.target.value } }))
            }
            placeholder="Buyer Name"
          />

          <textarea
            className="po-textarea"
            rows={4}
            value={poData.deliver_to}
            onChange={(e) =>
              setPoData(prev => ({ ...prev, deliver_to: e.target.value }))
            }
            placeholder="Deliver To Address"
          />

          <input
            type="text"
            className="po-input"
            value={poData.supplier.gstin}
            onChange={(e) =>
              setPoData(prev => ({ ...prev, supplier: { ...prev.supplier, gstin: e.target.value } }))
            }
            placeholder="GSTIN"
          />

          <input
          type="text"
          className="po-input"
          value={poData.supplier.contact}
          onChange={(e) =>
            setPoData(prev => ({ ...prev, supplier: { ...prev.supplier, contact: e.target.value } }))
          }
          placeholder="Contact"
        />

            <input
          type="text"
          className="po-input"
          value={poData.supplier.email}
          onChange={(e) =>
            setPoData(prev => ({ ...prev, supplier: { ...prev.supplier, email: e.target.value } }))
          }
          placeholder="Email"
        />
        </div>
</div>

{/* <div>
  <h4>Deliver To</h4>
  <pre>{poData.deliver_to}</pre>
</div> */}

        {/* ITEMS TABLE */}
        <table className="po-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Item & Description</th>
              <th>Qty</th>
              <th>Rate</th>
              <th>IGST</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {poData.items.map((item, index) => {
              const amount = item.qty * item.rate;
              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td style={{ whiteSpace: "pre-line" }}>
                    {item.description}
                  </td>
                  <td>{item.qty}.00 NOS</td>
                  <td>{item.rate.toFixed(2)}</td>
                  <td>{item.igst}%</td>
                  <td>{amount.toFixed(2)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {/* SUMMARY BOX */}
        <div className="po-summary-box">
          <div>Sub Total : {totals.subtotal.toFixed(2)}</div>
          <div>IGST 18% : {totals.igst.toFixed(2)}</div>
          <div className="total">Total : ₹{totals.total.toFixed(2)}</div>
        </div>

        {/* TERMS */}
        <div className="po-terms">
          <h4>Terms & Conditions</h4>
          <p>{poData.terms}</p>
        </div>

        {/* SIGNATURE */}
        <div className="po-signature">
          Authorized Signature
        </div>

      </div>
    </div>
  );
};

export default PoCreate;